import { render } from "./ProductsSourced.vue?vue&type=template&id=7249fa9c"
import script from "./ProductsSourced.vue?vue&type=script&lang=js"
export * from "./ProductsSourced.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__